import {ProductsRelDocs} from "../../interfaces";
import ProductPriceFormat from "../../../product-price/product-price-format";
import {useAppSelector} from "../../data-services/store";
import React from "react";
import {rootActions} from "../../../../account/change-sbs-billing-info/data/store";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";
import {cloneDeep} from "lodash";
import {useAppDispatch} from "../../../../subscriptions/DAL/store";
import InfoIcon from "../../../../../ui/svg/common/info";
import PRDPriceSubscriptionPlanPopup from "./prd-pricesubscription-plan-popup";
import TimerCountDown from "../../../../../ui/clock/count-down-timer/count-down-timer";
import {PriceDifferent} from "../../../../subscriptions/components/price-different";
import {SubscriptionPlanModel} from "../../../../subscriptions/interfaces";
interface IProductBuyButtonProps {
    product: ProductsRelDocs,
    isGoogleShoppingFeed?: boolean,
}
/**
 * the entry point
 */
const PRDPriceDifferentSubscriptionPlan = (props: IProductBuyButtonProps) => {
    const dispatch = useAppDispatch();

    const product = props.product;

    const IsSubscriptionPlanPopupShown = useAppSelector((store) => store.IsSubscriptionPlanPopupShown);
    //console.log('PRDPriceSubscriptionPlan: ',product);
    const productsRelDocsInitial_List = useAppSelector((store) => store.productsRelDocsInitial);
    const _productOptions = cloneDeep(productsRelDocsInitial_List) as ProductsRelDocs[];
    const isAnnual = product.optionName.toLowerCase() === 'annual';
    const planAnnual = _productOptions.find(o=>o.optionName.toLowerCase() === 'annual');

    const planMonthly = _productOptions.find(o=>o.optionName.toLowerCase() === 'monthly');

    if(!planAnnual || !planMonthly)
        return <></> ;

    //const planAnnualPrice:number =Number((planAnnual.msrp / 12).toFixed(2));
    //const productPriceSave:number = Number(((planMonthly.msrp * 12) - planAnnual.msrp).toFixed(2));


    // const openPopup = () => {
    //     dispatch(
    //         rootActions.main({
    //             IsSubscriptionPlanPopupShown: true,
    //             PlanPriceSavePopupShown: productPriceSave,
    //             PlanPricePopupShown: planAnnual.msrp
    //         })
    //     );
    //
    //     sendGAEvent('Click','You’re save 2 months free');
    // };
    const goToAnnual = () => {
        dispatch(
            rootActions.main({
                isProductOptionsSelected: true,
                productsRelDocsInitialSelected: planAnnual
            })
        );

        sendGAEvent('Click','Pay annually & save 2 months');
    };

    return (

            <>
                { isAnnual &&
                    <div className={`price-different-subscription-plan flex justify-start mt-4 w-full text-2xl md:text-3 font-bold`}>
                        <PriceDifferent plan={{skuPrice: product.skuPrice, skU_MSRP: product.msrp} as SubscriptionPlanModel} isStarter={true}  isPopup={true} isAnnual={true} showCounter={true}/>
                        {/* prices row #1: different prices / with coupon */}
                        {/*<div className="annual-price text-lg lg:text-xl line-through">
                            <ProductPriceFormat price={product.msrp}/>
                            <span className="text-lg font-normal"> /year</span>
                        </div>
                        <div className="mt-2 text-yellow-400 text-xl font-bold">
                            Limited Time Offer
                        </div>
                        <div className="mt-2 annual-price text-2xl lg:text-3xl font-bold">
                            <ProductPriceFormat price={product.skuPrice}/>
                            <span className="text-lg font-normal"> for the first year</span>
                        </div>
                        <div className="">
                            <div className="w-full timer-container mt-4 mb-4">
                                <div className="pb-1 text-lg">Offer ends:</div>
                                <div className="w-full flex items-center justify-start">
                                   <span className="text-xl font-bold"> <TimerCountDown
                                       expiredWhenNumber={0}
                                       timerType=""
                                       loadDataFromHtml="subscription-timer-2"
                                   />
                                       </span>
                                </div>
                            </div>
                        </div>*/}

                    </div>
                }
                {!isAnnual &&
                    <div className={`price-subscription-plan flex flex-col`}>
                        {/* prices row #1: different prices / with coupon */}
                        <div className="monthly-price text-2xl lg:text-3xl font-bold">
                            <ProductPriceFormat price={planMonthly.msrp}/>
                            <span className="text-lg font-normal"> /month</span>
                        </div>
                        <div className="mt-2 mb-2 w-full flex items-center">
                            <div className="pr-2"><InfoIcon width="22px" color={"white"}/></div>
                            <span className="">
                            <button
                                type="button"
                                onClick={ goToAnnual }
                                className="underline cursor-pointer">
                                Pay annually
                            </button>
                            <span> &amp; </span>
                            <span className="text-yellow-400">save</span>
                        </span>
                    </div>


                </div>

            }
                {
                    IsSubscriptionPlanPopupShown &&   <PRDPriceSubscriptionPlanPopup />
                }
            </>
    )
};

export default PRDPriceDifferentSubscriptionPlan;